import { memo, useRef, useMemo, FC } from 'react'
import { Input, FormLabel, Flex } from '@chakra-ui/react'

import { callbackOnPressKey } from 'utils/events'

type Props = {
  id?: string
  limit: number
  totalItems: number
  onChangePage: (newPage: number) => void
}

const PageShortCut: FC<Props> = ({ id = 'pagination-shortcut', limit = 10, totalItems, onChangePage }) => {
  const inputRef = useRef<HTMLInputElement | null>(null)

  const maxPages = useMemo(() => {
    return Math.ceil(totalItems / limit)
  }, [totalItems, limit])

  const goToPage = () => {
    const page = Number(inputRef.current?.value)
    const pageExist = page * limit < totalItems
    let newPage = pageExist ? Number(page) : maxPages
    if (page < 0) newPage = 1
    onChangePage(Number(newPage || 1))
  }

  return (
    <Flex align="center" justify="center" gap={1}>
      <FormLabel minWidth="min-content" htmlFor={id} m={0}>
        Ir para:{' '}
      </FormLabel>

      <Input id={id} ref={inputRef} p={2} w="50px" onKeyUp={(event) => callbackOnPressKey(event, () => goToPage())} />
    </Flex>
  )
}

export default memo(PageShortCut)
